export default __webpack_public_path__ + "static/media/docx.e911f1a1.svg";